import React from "react";
import { INDUSTRY, AUDITS } from "../../../core/theme/auditsTheme";
import GatheringStrip from "./GatheringStrip";
import SnapshotRow from "./SnapshotRow";
import CoverageMap from "./CoverageMap";

// Top right: the data gathering strip, then the selected industry's Snapshots
// (the stage 1 rows: pills, tags, running progress and Stop), searchable by
// name or tag, beside the coverage map. Every row is a Market Snapshot.
//   rows: this industry's Snapshots after the search   total: before it
export default function MarketPanel({ industry, niche, rollupState, rows, total, jobSearch, setJobSearch, onOpenJob, onStopJob }) {
  const mapMessage = !industry.nicheId ? "No map for Snapshots with no niche."
    : rollupState.status === "loading" ? "Loading the map…"
    : rollupState.status !== "ready" ? "The map couldn't be loaded."
    : null;

  return (
    <section aria-label="Market Audits and Snapshots" className={`${INDUSTRY.panel} ${INDUSTRY.market}`}>
      <GatheringStrip industry={industry} niche={niche} />
      <div className={INDUSTRY.marketBody}>
        <div className={INDUSTRY.marketList}>
          <div className={INDUSTRY.marketHead}>
            <h2 className={INDUSTRY.label}>Market Audits and Snapshots</h2>
            <span className={AUDITS.titleCount}>{total}</span>
          </div>
          <input
            className={AUDITS.search} value={jobSearch} onChange={e => setJobSearch(e.target.value)}
            placeholder="Search by name or tag…" aria-label="Search snapshots"
          />
          <div className={INDUSTRY.marketRows}>
            {rows.length === 0 ? (
              <p className={`${INDUSTRY.note} py-6 text-center`}>No snapshots match your search.</p>
            ) : (
              rows.map(job => <SnapshotRow key={job.id} job={job} onOpen={onOpenJob} onStop={onStopJob} showBar />)
            )}
          </div>
        </div>
        <CoverageMap niche={mapMessage ? null : niche} message={mapMessage} />
      </div>
    </section>
  );
}
